export const defaultState = {
  isError: false,
  message: '',
  status: null,
};
